module.exports = __webpack_public_path__ + "static/flags/KM-77b01e3e9eff6b5b7b0cdd75e1a436c0.gif";